module.exports = __webpack_public_path__ + "img/4028bf5.png";